import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import SalesFiltersDialog from "./SalesFiltersDialog";
import { displayMultiSelect } from "../Utility/ChipDisplay";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface ISalesFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function SalesFilters({ callTableViewModel, setCallTableViewModel }: ISalesFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                callTableViewModel.filters.salesFilters.sale ? 'Sale' : 'No Sale'
            }
            {
                displayMultiSelect(callTableViewModel.filters.salesFilters.saleType, 'Sale Type')
            }
            {
                displayMultiSelect(callTableViewModel.filters.salesFilters.productType, 'Product Type')
            }
            {
                displayMultiSelect(callTableViewModel.filters.salesFilters.product, 'Product')
            }
            {
                displayMultiSelect(callTableViewModel.filters.salesFilters.productOffer, 'Product Offer')
            }
            {
                callTableViewModel.filters.salesFilters.productReference ?
                    ` - ${callTableViewModel.filters.salesFilters.productReference}`
                    : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <SalesFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}